import React from "react";

/**
 * Small, reusable transparency badges so users can always see where a piece of
 * content or data comes from (client request: critic/user scores and any
 * AI-generated content must be clearly attributed).
 */

// A neutral "where did this come from" chip, e.g. "via Metacritic", "RAWG".
export const SourceChip = ({ children, title }) => (
  <span
    title={title}
    className="inline-flex items-center gap-1 rounded-full border border-white/12 bg-white/[0.04] px-2 py-0.5 text-[0.62rem] font-semibold uppercase tracking-wide text-white/55"
  >
    {children}
  </span>
);

// Marks content that was produced by AI so it's never mistaken for official copy.
export const AiBadge = ({ title = "This content is generated by AI and may contain inaccuracies." }) => (
  <span
    title={title}
    className="inline-flex items-center gap-1 rounded-full border border-brand-purple/50 bg-brand-purple/15 px-2.5 py-0.5 text-[0.62rem] font-bold uppercase tracking-wide text-brand-purple-light"
  >
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15l-1.9-4.1L5.5 9l4.6-1.4L12 3Z" />
    </svg>
    AI-generated
  </span>
);

// Marks content that comes straight from the official source data.
export const OfficialBadge = ({ source, title }) => (
  <span
    title={title || "Official description from the game's source data."}
    className="inline-flex items-center gap-1 rounded-full border border-neon-lime/50 bg-neon-lime/10 px-2.5 py-0.5 text-[0.62rem] font-bold uppercase tracking-wide text-neon-lime"
  >
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
    Official{source ? ` · ${source}` : ""}
  </span>
);
